import React from 'react';
import { useDragLayer } from 'react-dnd';

import DraftEditor from 'Shared/components/DraftEditor/DraftEditor';

import './ItemDragLayer.scss';

const getItemStyles = currentOffset => {
  if (!currentOffset) {
    return { display: 'none' };
  }

  const { x, y } = currentOffset;
  return { transform: `translate(${x}px, ${y}px)` };
};

const collect = monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
});

export function ItemDragLayer() {
  const { isDragging, item, currentOffset } = useDragLayer(collect);

  if (!isDragging) return null;
  if (!item.dragUuid) return null;

  return (
    <div className="drag-layer-container">
      <div className="drag-layer-item" style={getItemStyles(currentOffset)}>
        {item.dragUuid.length === 1 && <DraftEditor readOnly editorState={item.body} onChange={() => null} />}
        {item.dragUuid.length > 1 && `Dragging ${item.dragUuid.length} items`}
      </div>
    </div>
  );
}
